import BitPaymentStep from './BitPaymentStep';
import CreditCardStep from './CreditCardStep';
import OfflineDonationStep from './OfflineDonationStep';
import { DonationFormState, DonationPageConfig } from './types';

interface Props {
  config: DonationPageConfig;
  form: DonationFormState;
  onSuccess: () => void;
  onError: (message: string) => void;
}

const DonationStep2 = ({ config, form, onSuccess, onError }: Props) => {
  switch (form.paymentMethod) {
    case 'CreditCard':
      return <CreditCardStep config={config} form={form} onSuccess={onSuccess} onError={onError} />;
    case 'Bit':
      return <BitPaymentStep config={config} form={form} onError={onError} />;
    case 'ManualBankTransfer':
      return <OfflineDonationStep fundId={config.fundId} form={form} type="BankTransfer" onSuccess={onSuccess} onError={onError} />;
    case 'Check':
      return <OfflineDonationStep fundId={config.fundId} form={form} type="Check" onSuccess={onSuccess} onError={onError} />;
    default:
      return null;
  }
};

export default DonationStep2;
